<mat-toolbar class="bar-filler"></mat-toolbar>
<div class="small-margin"> 
   <div class="small-margin floating-text big bold">{{fullName}}</div>
   <div class="floating-text">{{phone}}</div>
</div>
<div>
    <div class="floating-text bold">{{'Pages.MyProfile.MyOrders' | translate}}({{placeName}})</div>
    <mat-divider></mat-divider>
</div>
<div *ngIf="isLoading" class="floating-container">
    <mat-spinner class="floating-spinner"></mat-spinner>
</div>
<div *ngIf="!isLoading">
    <mat-list style="padding: 0; margin: 0;">
        <mat-list-item *ngFor="let order of orderhistory" matRipple class="no-outline pointer-cursor" style="height: auto;" (click)="orderTapped(order)">
            <div class="small-margin">
                <div class="flex-container-center">
                    <div class="label">{{order.Name}}</div>
                    <div class="small-detail small-margin">{{order.OrderTimeString}}</div>
                </div>
                <div class="detail"> {{order.Description}}</div>
            </div>
            <div class="block float-right price-label">{{order.StatusString}}</div>
            <mat-divider></mat-divider>
        </mat-list-item>
    </mat-list>
</div>
<mat-toolbar color="primary" class="top-bar">
    <button mat-icon-button (click)="back()">
        <mat-icon>arrow_back</mat-icon>
    </button>
    <div>{{'Pages.MyProfile.Title' | translate}}</div>
    <div class="filler"></div>
    <button mat-icon-button (click)='editProfile()'>
        <mat-icon>edit</mat-icon>
    </button>
</mat-toolbar>
<button mat-fab style="position: fixed; bottom: 30px; right: 30px;" *ngIf="!isLoading" color="primary" (click)="getHistory()">
    <mat-icon>refresh</mat-icon>
</button>